import { render } from "./DonorDetailsView.vue?vue&type=template&id=21a0c516&scoped=true"
import script from "./DonorDetailsView.vue?vue&type=script&lang=js"
export * from "./DonorDetailsView.vue?vue&type=script&lang=js"

import "./DonorDetailsView.vue?vue&type=style&index=0&id=21a0c516&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21a0c516"]])

export default __exports__